/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_WeightInputs */

const en_ui_thresholds_weight = /** @type {(inputs: Ui_Thresholds_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight (kg)`)
};

const de_ui_thresholds_weight = /** @type {(inputs: Ui_Thresholds_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht (kg)`)
};

/**
* | output |
* | --- |
* | "Weight (kg)" |
*
* @param {Ui_Thresholds_WeightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_weight = /** @type {((inputs?: Ui_Thresholds_WeightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_WeightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_weight(inputs)
	return de_ui_thresholds_weight(inputs)
});